module.exports = __webpack_public_path__ + "static/img/solutionConceptPic2.4d60bae.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/solutionConceptPic2.jpg
// module id = heg6
// module chunks = 0